<template lang="pug">
v-container(
  fluid
  id="website-theme-preview"
  fill-height
  class=" tw-p-0 tw-m-0  tw-items-start tw-content-start tw-overflow-x-hidden"
)
  kubiqa-website-themes-theme-c-components-shared-top-navigation(
    changeOnScroll="false"
    titleColor="tw-text-black"
    appBarBg="tw-bg-white tw-border tw-border-gray-lighten-2 tw-rounded-lg pt-12 pb-16 mt-1"
  )
  div(class="d-flex flex-row flex-grow-1 tw-w-full tw-z-90 tw-pt-18 tw-mt-32")
    v-container(fluid class="pa-0 ma-0")
      v-row(justify="center")
        v-col(cols="8")
          kubiqa-website-themes-theme-c-components-shared-carousel(:images="images" class="tw-w-full tw-relative tw-z-10")
        v-col(cols="3")
          v-container(class="tw-border tw-border-gray-lighten-2 tw-overflow-hidden tw-rounded-md")
            v-row(class="")
              v-col
                span(class=" tw-text-gray-darken-1 tw-font-extrabold tw-text-2xl") Contact
            v-row
              v-col
                v-text-field(label="Name" outlined hide-details)
            v-row
              v-col
                v-text-field(label="Last Name" outlined hide-details)
            v-row
              v-col
                v-text-field(label="Phone" outlined hide-details)
            v-row
              v-col
                v-text-field(label="Email" outlined hide-details)
            v-row
              v-col
                v-textarea(label="Message" outlined hide-details)
            v-row(class="tw-pt-2")
              v-col
                v-btn(block elevation="0" color="#E7C873")
                  span(class=" tw-font-bold tw-text-xl") SEND
  div(class="d-flex flex-row tw-mx-auto tw-flex-wrap tw-min-h-full  tw-content-start tw-mt-12 tw-w-full tw-bg-gray-lighten-4 ")
    v-container(fluid class=" tw-bg-white tw-my-12 tw-rounded-md tw-w-10/12")
      v-row(justify="center" class="tw-py-8")
        // Right column
        v-col(cols="10" xl="9")
          v-row
            v-col(cols="9" xl="10")
              div
                span(class="tw-text-3xl tw-font-bold") {{ this.$faker().lorem.sentence(3) }}
              div(class="tw-pt-2")
                v-icon(color="text-secondary") mdi-map-marker-outline
                span(class="tw-text-lg ") {{ this.$faker().address.streetAddress(true) }}, {{ this.$faker().address.county() }}, {{ this.$faker().address.stateAbbr() }}
            v-col(cols="3" xl="2")
              v-row(justify="end")
                v-col(cols="auto")
                  div(class="text-right tw-text-gray-darken-1")
                    span(class="tw-text-md tw-font-bold") {{ this.$faker().random.arrayElement(['Rent', 'Sale']) }}
                  div(class="tw-pt-2")
                    span(class="tw-text-2xl tw-font-bold") ${{ this.$faker().finance.amount(10000, 100000, 0) }}
              v-row(justify="end" class="tw--mt-6 tw-py-0 tw-my-0")
                v-col(cols="auto")
                  v-btn(outlined color="black" @click="method")
                    v-icon mdi-share-variant
                    span SHARE
          // Description
          v-row
            v-col
              div
                span(class=" tw-text-xl tw-font-bold") Description
              div(class="tw-pt-2")
                span {{ this.$faker().lorem.paragraphs(3) }}
          //Details
          v-row(class="tw-pt-4")
            v-col
              v-row
                v-col
                  span(class="tw-text-xl tw-font-bold") Details
              v-row
                v-col
                  span 1 bedroom
                v-col
                  span 2 bathroom
                v-col
                  span 220 m2
          // Floor Plans
          v-row(class="tw-pt-4")
            v-col
              div
                span(class=" tw-text-xl tw-font-bold") Floor Plans
              div(class="tw-pt-2")
                v-img(src="https://via.placeholder.com/500x300")

          // Map
          v-row(class="tw-pt-4")
            v-col
              div
                span(class="tw-text-xl tw-font-bold") Map
              div(class=" tw-pt-2")
                kubiqa-misc-map

          //Similar properties
  v-row(justify="center" class="tw-pt-6 ")
    v-col(cols="10")
      div(class="tw-pb-6")
        span(class=" tw-text-xl tw-font-bold") More listings
      div(class="d-flex flex-row flex-wrap tw-mx-auto tw-pb-6")
        div(
          v-for="item in 2"
          :key="item.id"
          class=" tw-w-1/2 tw-mx-0 tw-px-0 "
          :class="{ 'pr-2': item % 2 !== 0, 'pl-2': item % 2 === 0 }"
        )
          kubiqa-website-themes-theme-c-components-shared-listing-card

        // Left column

  kubiqa-website-themes-theme-c-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      images: [],
    };
  },
  created() {
    for (let index = 0; index < 20; index++) {
      var image = {};

      image.description = this.$faker().lorem.sentence();
      image.href = image.src = 'https://picsum.photos/seed/' + this.$faker().datatype.number(5) + '/650/450';
      this.images.push(image);
    }
  },
};
</script>
